import { __extends } from 'tslib';

var ConfigurationLoadError = /** @class */ (function (_super) {
    __extends(ConfigurationLoadError, _super);
    function ConfigurationLoadError(message, code, options) {
        var _this = _super.call(this, message) || this;
        // Fix prototype chain for proper instanceof checks
        Object.setPrototypeOf(_this, ConfigurationLoadError.prototype);
        _this.name = 'ConfigurationLoadError';
        _this.code = code;
        _this.cause = options === null || options === void 0 ? void 0 : options.cause;
        return _this;
    }
    return ConfigurationLoadError;
}(Error));

export { ConfigurationLoadError as default };
